/* KajuReise Tutorial - gefuehrter Bogenbau (Station 1 der Entdeckungsreise 2.0).

   Staged micro-tasks on top of the REAL statics/collapse kernels inherited
   unchanged from KajuBauprobe (window.KajuBauprobe._internals):

     A  rettung   - arch of 2x orange per side, keystone missing: collapses,
                    then the user rescues it by placing the yellow keystone
     B  dreigelb  - build the simplest arch from 3 yellow stones
     C  tausch-o  - mark a yellow side stone (mirror auto-marks), tap orange:
                    1x gelb = 2x orange -> small parabolic arch
     D  tausch-g  - same trick: 1x orange = 2x gruen
     E  weiche    - guided build of a switch arch (orange, worange, orange +
                    orange/orange on the switch, yellow bridge keystone on top)

   All stage configurations verified headless against the kernel (2026-07-11):
   A/B/C/D/E stable, A without keystone collapses in ~1s.

   Interaction model: View-Tap-Asymmetry - every placement works BOTH by
   dragging into the glowing gap AND by simply tapping the tray stone.        */
(function () {
  'use strict';

  var IS_BROWSER = typeof window !== 'undefined' && typeof document !== 'undefined';
  var CORE = IS_BROWSER
    ? (window.KajuBauprobe && window.KajuBauprobe._internals)
    : (typeof require !== 'undefined' ? require('../../kaju-erlebnis-nacht/js/bauprobe.js')._internals : null);
  if (IS_BROWSER && !CORE) return;

  var STONES = CORE.STONES;
  var W = 820, H = 700;
  var TRAY_H = 96, TRAY_GAP = 14, TRAY_Y = H - TRAY_H - 12;
  var GROUND_Y = TRAY_Y - 40;                 // screen y of world ground (y=0)
  var PAPIER = '#faf7f4', BRAUN = '#532c29', TUERKIS = '#0096ae';

  /* ================= stage definitions ================= */
  // built is a node tree (like bauprobe.js): {type, inverted, side?[...]}
  function o() { return { type: 'orange', inverted: false }; }
  function g() { return { type: 'gelb', inverted: false }; }
  function gr() { return { type: 'gruen', inverted: false }; }

  var STAGES = [
    {
      id: 'rettung',
      enter: function (s) {
        s.built = [o(), o()]; s.key = null; s.bridges = null;
        s.tray = []; s.steps = []; s.stepIdx = 0; s.mode = 'collapse-intro';
        setTask('Fast fertig &ndash; nur der <b>Schlussstein</b> fehlt. Was passiert wohl ohne ihn?');
      },
      // after the collapse: rescue task
      afterCollapse: function (s) {
        s.mode = 'build';
        s.tray = [{ type: 'gelb', count: 1 }];
        s.steps = [{ kind: 'key', type: 'gelb' }]; s.stepIdx = 0;
        setTask('Ohne Stecken, nur durch Balance. <b>Setz den gelben Schlussstein ein</b> und rette den Bogen.');
      },
      doneMsg: 'Ger&auml;ttet &ndash; der Bogen tr&auml;gt sich selbst.',
      reward: null
    },
    {
      id: 'dreigelb',
      enter: function (s) {
        s.built = []; s.key = null; s.bridges = null;
        s.tray = [{ type: 'gelb', count: 3 }];
        s.steps = [{ kind: 'side', type: 'gelb', node: g }, { kind: 'key', type: 'gelb' }];
        s.stepIdx = 0; s.mode = 'build';
        setTask('Jetzt von Anfang an: <b>bau den einfachsten Bogen aus drei Gelben.</b> Tipp den Stein an &ndash; oder zieh ihn in die leuchtende L&uuml;cke.');
      },
      doneMsg: 'Dein erster eigener Bogen steht.',
      reward: { id: 'tut-gelb', msg: '+1 Gratisstein · Dein erster gelber Bogenstein.' }
    },
    {
      id: 'tausch-orange',
      enter: function (s) {
        s.built = [g()]; s.key = 'gelb'; s.bridges = null;
        s.tray = [{ type: 'orange', count: 2 }];
        s.steps = []; s.stepIdx = 0; s.mode = 'replace';
        s.replace = { from: 'gelb', to: 'orange', done: false };
        setTask('Wusstest du? <b>1 &times; Gelb = 2 &times; Orange.</b> Markiere einen gelben Seitenstein &ndash; und tipp dann unten auf Orange.');
      },
      doneMsg: 'Der kleine Parabelbogen steht.',
      reward: { id: 'tut-orange', msg: '+1 Gratisstein · Dein erster oranger Bogenstein.' }
    },
    {
      id: 'tausch-gruen',
      enter: function (s) {
        s.built = [o(), o()]; s.key = 'gelb'; s.bridges = null;
        s.tray = [{ type: 'gruen', count: 2 }];
        s.steps = []; s.stepIdx = 0; s.mode = 'replace';
        s.replace = { from: 'orange', to: 'gruen', done: false };
        setTask('Genauso weiter: <b>1 &times; Orange = 2 &times; Gr&uuml;n.</b> Markiere einen orangen Stein, dann tipp auf Gr&uuml;n.');
      },
      doneMsg: 'Feiner aufgel&ouml;st &ndash; gleiche Mathematik.',
      reward: { id: 'tut-gruen', msg: '+1 Gratisstein · Dein erster gr&uuml;ner Bogenstein.' }
    },
    {
      id: 'weiche',
      enter: function (s) {
        s.built = []; s.key = null; s.bridges = null;
        s.steps = [
          { kind: 'side', type: 'orange', node: o },
          { kind: 'side', type: 'worange', node: function () { return { type: 'worange', rot: 0, side: [] }; } },
          { kind: 'side', type: 'orange', node: o },
          { kind: 'branch', type: 'orange', node: o },
          { kind: 'branch', type: 'orange', node: o },
          { kind: 'bridge', type: 'gelb' }
        ];
        s.stepIdx = 0; s.mode = 'build';
        syncTrayToStep(s);
        setTask('Zum Schluss die K&ouml;nigsdisziplin: <b>eine Weiche.</b> Setz die Steine der Reihe nach in die leuchtenden L&uuml;cken.');
      },
      doneMsg: 'Ein Bogen, der sich verzweigt &ndash; und alles tr&auml;gt.',
      reward: null
    }
  ];

  /* ================= state ================= */

  var canvas, ctx, taskEl, tipEl, verdictEl, resetBtn, nextBtn, stagesEl, moreEl;
  var visible = false, introPending = false;
  var cam = { z: 22, ox: W / 2, tz: 22, tox: W / 2 };
  var trayRects = [];
  var lastAction = 0, tipShown = false;
  var audioCtx = null;

  var s = {
    stage: 0, mode: 'build',       // build | replace | collapse-intro | collapsing | result | done
    built: [], key: null, bridges: null,
    tray: [], steps: [], stepIdx: 0,
    replace: null, marked: -1,     // marked left-item chain index (replace stages)
    drag: null, world: null, collapseNext: null,
    resultAt: 0, pulse: 0
  };

  /* ================= model helpers ================= */

  function model() {
    var m = CORE.archModel(s.built, s.key, s.bridges || {});
    // archModel returns early (no chain) for an empty build - normalise
    if (!m.chain) m.chain = m.key ? [m.key] : [];
    return m;
  }

  function itemKey(it) {
    return (it.chain ? it.chain.join('.') : '') + ':' + (it.idx != null ? it.idx : 'k') + (it.isBridge ? ':b' : '');
  }

  // the switch node in built (stage E) - side stones are appended to its side[]
  function switchNode() {
    for (var i = 0; i < s.built.length; i++) if (STONES[s.built[i].type].sw) return s.built[i];
    return null;
  }

  // ghost geometry for the current step: the item(s) that WOULD appear
  function ghostItems() {
    if (s.mode !== 'build' || s.stepIdx >= s.steps.length) return [];
    var step = s.steps[s.stepIdx];
    if (step.kind === 'key') {
      var mk = CORE.archModel(s.built, step.type, {});
      return mk.key ? [mk.key] : [];
    }
    var before = model();
    var builtNext = JSON.parse(JSON.stringify(s.built));
    var bridgesNext = s.bridges;
    if (step.kind === 'side') builtNext.push(step.node());
    else if (step.kind === 'branch') {
      for (var i = 0; i < builtNext.length; i++) if (STONES[builtNext[i].type].sw) { builtNext[i].side.push(step.node()); break; }
    } else if (step.kind === 'bridge') {
      var swIdx = -1;
      for (var j = 0; j < s.built.length; j++) if (STONES[s.built[j].type].sw) swIdx = j;
      bridgesNext = {}; bridgesNext[String(swIdx)] = { type: step.type };
    }
    var after = CORE.archModel(builtNext, s.key, bridgesNext || {});
    var seen = {};
    before.chain.forEach(function (it) { seen[itemKey(it) + (it.mirrored ? 'm' : '')] = true; });
    return after.chain.filter(function (it) { return !seen[itemKey(it) + (it.mirrored ? 'm' : '')]; });
  }

  // apply the current step (called from tap-to-place or a successful drop)
  function placeStep() {
    var step = s.steps[s.stepIdx];
    if (!step) return;
    if (step.kind === 'key') s.key = step.type;
    else if (step.kind === 'side') s.built.push(step.node());
    else if (step.kind === 'branch') { var sw = switchNode(); if (sw) sw.side.push(step.node()); }
    else if (step.kind === 'bridge') {
      var swIdx = -1;
      for (var j = 0; j < s.built.length; j++) if (STONES[s.built[j].type].sw) swIdx = j;
      s.bridges = {}; s.bridges[String(swIdx)] = { type: step.type };
    }
    takeFromTray(step.type);
    s.stepIdx++;
    buzz(12); clickSound();
    if (s.stepIdx >= s.steps.length) finishStage();
    else { syncTrayToStep(s); }
  }

  function syncTrayToStep(st) {
    // "immer nur die Steine in der Auswahl, die notwendig sind" (Kai)
    if (st.stage === undefined && !st.steps) return;
    if (STAGES[s.stage].id !== 'weiche') return;
    var need = {};
    for (var i = st.stepIdx; i < st.steps.length; i++) {
      need[st.steps[i].type] = (need[st.steps[i].type] || 0) + 1;
    }
    st.tray = [];
    // stable order: next needed type first
    var order = [];
    for (var k = st.stepIdx; k < st.steps.length; k++) {
      if (order.indexOf(st.steps[k].type) < 0) order.push(st.steps[k].type);
    }
    order.forEach(function (t) { st.tray.push({ type: t, count: need[t] }); });
    layoutTray();
  }

  function takeFromTray(type) {
    for (var i = 0; i < s.tray.length; i++) {
      if (s.tray[i].type === type) {
        s.tray[i].count--;
        if (s.tray[i].count <= 0) s.tray.splice(i, 1);
        layoutTray();
        return;
      }
    }
  }

  /* ================= replace mechanic (stages C/D) ================= */

  // chain layout: [left..., key?, right...]; map a chain hit to a left index
  function leftIndexFromChainIdx(m, ci) {
    var nL = m.left.length, hasKey = !!m.key;
    if (ci < nL) return ci;                          // left item
    if (hasKey && ci === nL) return -2;              // keystone
    var r = ci - nL - (hasKey ? 1 : 0);
    return r >= 0 && r < nL ? r : -1;                // mirrored right item
  }

  function tryMark(p) {
    var m = model();
    for (var i = 0; i < m.chain.length; i++) {
      if (inPoly(p, m.chain[i].poly.map(w2s))) {
        var li = leftIndexFromChainIdx(m, i);
        if (li === -2) { showTip('Der Schlussstein bleibt heute drin &ndash; markiere einen Seitenstein.'); return true; }
        if (li >= 0) {
          if (m.left[li].type !== s.replace.from) {
            showTip('Markiere einen ' + label(s.replace.from) + ' Stein.');
            return true;
          }
          s.marked = (s.marked === li) ? -1 : li;
          buzz(8);
          if (s.marked >= 0) showTip('Und jetzt: tipp unten auf ' + label(s.replace.to) + '.');
          else hideTip();
          return true;
        }
      }
    }
    return false;
  }

  function label(type) {
    return { gelb: 'gelben', orange: 'orangen', gruen: 'gr&uuml;nen' }[type] || type;
  }

  function tryReplace(type) {
    if (type !== s.replace.to) { showTip('F&uuml;r diesen Tausch brauchst du ' + label(s.replace.to) + ' Steine.'); return; }
    if (s.marked < 0) { showTip('Markiere zuerst einen ' + label(s.replace.from) + ' Stein im Bogen.'); return; }
    var two = [{ type: type, inverted: false }, { type: type, inverted: false }];
    s.built.splice.apply(s.built, [s.marked, 1].concat(two));
    s.marked = -1;
    takeFromTray(type); takeFromTray(type);
    s.replace.done = true;
    buzz(12); clickSound();
    hideTip();
    finishStage();
  }

  /* ================= stage flow ================= */

  function enterStage(i) {
    s.stage = i; s.marked = -1; s.drag = null; s.world = null; s.mode = 'build';
    hideVerdict(); hideTip(); nextBtn.hidden = true;
    STAGES[i].enter(s);
    layoutTray();
    renderStageDots();
    lastAction = now(); tipShown = false;
    if (window.KajuReise) window.KajuReise.setSection('tutorial', i);
    // the collapse must not run off-screen - the user would miss the "Rumms"
    if (s.mode === 'collapse-intro') {
      if (visible) startIntroCollapse();
      else introPending = true;
    }
  }

  function startIntroCollapse() {
    // show the incomplete arch briefly, then let the honest physics speak
    var m = model();
    retargetPolys(collectPolys(m.chain, []));
    setTimeout(function () {
      if (STAGES[s.stage].id !== 'rettung' || s.mode !== 'collapse-intro') return;
      s.world = CORE.createCollapseWorld(model().chain);
      s.mode = 'collapsing';
      s.collapseNext = function () {
        showVerdict('Rumms.');
        showTip('Schwerkraft verzeiht nichts &ndash; ein Stein fehlt.');
        setTimeout(function () {
          s.world = null; hideVerdict(); hideTip();
          STAGES[s.stage].afterCollapse(s);
          layoutTray();
          lastAction = now();
        }, 1600);
      };
    }, 1300);
  }

  function finishStage() {
    var st = STAGES[s.stage];
    var ev = CORE.evaluateArch(s.built, s.key, s.bridges || {});
    s.mode = 'result'; s.resultAt = now();
    if (ev.state === 'stable') {
      showVerdict('Tr&auml;gt.');
      if (st.reward && window.KajuReise) window.KajuReise.earn(st.reward.id, st.reward.msg);
      showTip(st.doneMsg);
      var last = s.stage === STAGES.length - 1;
      setTimeout(function () {
        if (last) { s.mode = 'done'; markAllDots(); showDone(); }
        else nextBtn.hidden = false;
      }, 900);
    } else {
      // should not happen (configs verified) - stay honest if it ever does
      showVerdict(ev.state === 'critical' ? 'Wackelt.' : 'Hmm.');
      showTip('Knapp daneben &ndash; versuch es einfach noch einmal.');
      setTimeout(function () { enterStage(s.stage); }, 1800);
    }
  }

  function showDone() {
    setTask('Du baust jetzt B&ouml;gen, Tauschregeln und Weichen. <b>Unten geht die Reise weiter.</b>');
    if (moreEl) moreEl.hidden = false;
    renderStageDots();
  }

  function nextStage() {
    if (s.stage < STAGES.length - 1) enterStage(s.stage + 1);
  }

  /* ================= camera + drawing ================= */

  function collectPolys(items, ghosts) {
    var polys = [];
    items.forEach(function (it) { if (it.poly) polys.push(it.poly); });
    ghosts.forEach(function (it) { if (it.poly) polys.push(it.poly); });
    return polys;
  }

  function retargetPolys(polys) {
    if (!polys.length) { cam.tz = 24; cam.tox = W / 2; return; }
    var minx = 1e9, maxx = -1e9, maxy = 4;
    polys.forEach(function (poly) {
      poly.forEach(function (p) {
        if (p[0] < minx) minx = p[0];
        if (p[0] > maxx) maxx = p[0];
        if (p[1] > maxy) maxy = p[1];
      });
    });
    var w = Math.max(6, maxx - minx), h = Math.max(4, maxy);
    var z = Math.min((W * 0.72) / w, (GROUND_Y - 80) / h);
    cam.tz = Math.max(8, Math.min(40, z));
    cam.tox = W / 2 - ((minx + maxx) / 2) * cam.tz;
  }

  function w2s(p) { return [cam.ox + p[0] * cam.z, GROUND_Y - p[1] * cam.z]; }

  function drawPoly(pts, fill, opts) {
    opts = opts || {};
    ctx.beginPath();
    var q = w2s(pts[0]); ctx.moveTo(q[0], q[1]);
    for (var i = 1; i < pts.length; i++) { q = w2s(pts[i]); ctx.lineTo(q[0], q[1]); }
    ctx.closePath();
    if (opts.ghost) {
      ctx.globalAlpha = opts.alpha != null ? opts.alpha : 0.3;
      ctx.fillStyle = fill; ctx.fill();
      ctx.globalAlpha = 1;
      ctx.lineWidth = 2; ctx.setLineDash([6, 5]);
      ctx.strokeStyle = 'rgba(250,247,244,.75)'; ctx.stroke();
      ctx.setLineDash([]);
    } else {
      ctx.save(); ctx.translate(4, 4); ctx.fillStyle = 'rgba(0,0,0,.28)'; ctx.fill(); ctx.restore();
      ctx.fillStyle = fill; ctx.fill();
      ctx.lineWidth = 2; ctx.strokeStyle = '#3a221c'; ctx.stroke();
      if (opts.marked) {
        ctx.lineWidth = 4; ctx.strokeStyle = TUERKIS; ctx.stroke();
      }
    }
  }

  function drawGround() {
    ctx.strokeStyle = 'rgba(250,247,244,.35)'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(26, GROUND_Y); ctx.lineTo(W - 26, GROUND_Y); ctx.stroke();
  }

  function layoutTray() {
    trayRects = [];
    if (!s.tray.length) return;
    var n = s.tray.length, tw = 96;
    var total = n * tw + (n - 1) * TRAY_GAP;
    var x0 = (W - total) / 2;
    for (var i = 0; i < n; i++) {
      trayRects.push({ type: s.tray[i].type, x: x0 + i * (tw + TRAY_GAP), y: TRAY_Y, w: tw, h: TRAY_H });
    }
  }

  function drawTray() {
    for (var i = 0; i < trayRects.length; i++) {
      var t = trayRects[i], entry = s.tray[i];
      if (!entry) continue;
      ctx.save(); ctx.translate(3, 3); ctx.fillStyle = 'rgba(0,0,0,.25)';
      ctx.fillRect(t.x, t.y, t.w, t.h); ctx.restore();
      ctx.fillStyle = STONES[t.type].color;
      ctx.fillRect(t.x, t.y, t.w, t.h);
      ctx.lineWidth = 2; ctx.strokeStyle = '#3a221c'; ctx.strokeRect(t.x, t.y, t.w, t.h);
      ctx.fillStyle = '#3a221c'; ctx.textAlign = 'center';
      ctx.font = '700 16px "Ciutadella", system-ui, sans-serif';
      ctx.fillText(STONES[t.type].label, t.x + t.w / 2, t.y + t.h - 12);
      if (entry.count > 1) {
        ctx.beginPath(); ctx.arc(t.x + t.w - 14, t.y + 14, 13, 0, 7);
        ctx.fillStyle = '#3a221c'; ctx.fill();
        ctx.fillStyle = PAPIER; ctx.font = '700 14px "Ciutadella", system-ui, sans-serif';
        ctx.fillText(String(entry.count), t.x + t.w - 14, t.y + 19);
      }
    }
  }

  function drawDrag() {
    if (!s.drag) return;
    ctx.globalAlpha = 0.85;
    ctx.fillStyle = STONES[s.drag.type].color;
    // the stone floats slightly above the finger (doc: finger occlusion)
    var y = s.drag.y - 34;
    ctx.fillRect(s.drag.x - 30, y - 30, 60, 60);
    ctx.lineWidth = 2; ctx.strokeStyle = '#3a221c';
    ctx.strokeRect(s.drag.x - 30, y - 30, 60, 60);
    ctx.globalAlpha = 1;
  }

  function drawCollapse() {
    var bodies = s.world.bodies;
    for (var i = 0; i < bodies.length; i++) {
      var b = bodies[i], cs = Math.cos(b.ang), sn = Math.sin(b.ang);
      var pts = b.outline.map(function (p) {
        return [b.pos[0] + p[0] * cs - p[1] * sn, b.pos[1] + p[0] * sn + p[1] * cs];
      });
      drawPoly(pts, STONES[b.type] ? STONES[b.type].color : '#9a8', {});
    }
  }

  function draw() {
    if (!ctx) return;
    ctx.clearRect(0, 0, W, H);
    s.pulse += 0.06;
    drawGround();

    if (s.mode === 'collapsing' && s.world) {
      CORE.stepWorld(s.world); CORE.stepWorld(s.world);   // 2x 1/120s = realtime
      drawCollapse();
      if (s.world.settled && s.collapseNext) { var f = s.collapseNext; s.collapseNext = null; f(); }
    } else {
      var m = model();
      var ghosts = (s.mode === 'build') ? ghostItems() : [];
      retargetPolys(collectPolys(m.chain, ghosts));
      var pulseA = 0.22 + 0.16 * (0.5 + 0.5 * Math.sin(s.pulse * 2));
      ghosts.forEach(function (it) { drawPoly(it.poly, STONES[it.type].color, { ghost: true, alpha: pulseA }); });
      for (var i = 0; i < m.chain.length; i++) {
        var li = s.mode === 'replace' ? leftIndexFromChainIdx(m, i) : -1;
        drawPoly(m.chain[i].poly, STONES[m.chain[i].type].color, { marked: li >= 0 && li === s.marked });
      }
    }
    cam.z += (cam.tz - cam.z) * 0.18;
    cam.ox += (cam.tox - cam.ox) * 0.18;
    drawTray();
    drawDrag();
    maybeHint();
  }

  /* ================= interaction ================= */

  function canvasXY(e) {
    var r = canvas.getBoundingClientRect();
    return [(e.clientX - r.left) * (W / r.width), (e.clientY - r.top) * (H / r.height)];
  }

  function trayHit(p) {
    for (var i = 0; i < trayRects.length; i++) {
      var t = trayRects[i];
      // generous hitbox for children's motor skills (doc: >=10mm targets)
      if (p[0] >= t.x - 6 && p[0] <= t.x + t.w + 6 && p[1] >= t.y - 10 && p[1] <= t.y + t.h + 10) return t;
    }
    return null;
  }

  function onDown(e) {
    lastAction = now(); hideHint();
    var p = canvasXY(e);
    var t = trayHit(p);
    if (t) {
      if (s.mode === 'build') {
        // start a drag; a plain tap (no movement) places directly on up
        s.drag = { type: t.type, x: p[0], y: p[1], sx: p[0], sy: p[1] };
        try { canvas.setPointerCapture(e.pointerId); } catch (_) { /* synthetic */ }
      } else if (s.mode === 'replace') {
        tryReplace(t.type);
      }
      return;
    }
    if (s.mode === 'replace') tryMark(p);
  }

  function onMove(e) {
    if (!s.drag) return;
    var p = canvasXY(e);
    s.drag.x = p[0]; s.drag.y = p[1];
  }

  function onUp(e) {
    if (!s.drag) return;
    var p = canvasXY(e), d = s.drag;
    s.drag = null;
    if (s.mode !== 'build' || s.stepIdx >= s.steps.length) return;
    var step = s.steps[s.stepIdx];
    if (d.type !== step.type) { showTip('Gerade brauchst du einen ' + label(step.type) + ' Stein.'); return; }
    var moved = Math.hypot(p[0] - d.sx, p[1] - d.sy);
    if (moved < 14) { placeStep(); return; }          // tap-to-place
    // drop: accept anywhere near the glowing gap (generous snap radius)
    var ghosts = ghostItems();
    for (var i = 0; i < ghosts.length; i++) {
      var c = w2s(ghosts[i].centroid);
      if (Math.hypot(p[0] - c[0], p[1] - (c[1] + 34)) < 130 || Math.hypot(p[0] - c[0], p[1] - c[1]) < 130) {
        placeStep(); return;
      }
    }
    // dropped elsewhere: stone glides back, no punishment (doc: fehlerverzeihend)
    showTip('Zieh den Stein in die leuchtende L&uuml;cke &ndash; oder tipp ihn einfach an.');
  }

  /* ================= hints / feedback ================= */

  function now() { return Date.now(); }

  function maybeHint() {
    if (tipShown) return;
    if ((s.mode === 'build' || s.mode === 'replace') && now() - lastAction > 5000) {
      tipShown = true;
      if (s.mode === 'build') showTip('Zieh den Stein in die leuchtende L&uuml;cke (oder tippe ihn an).');
      else showTip('Erst einen Stein im Bogen antippen &ndash; dann unten die neue Farbe.');
    }
  }
  function hideHint() { tipShown = false; }

  function setTask(html) { if (taskEl) taskEl.innerHTML = html; }
  function showTip(html) { if (tipEl) { tipEl.innerHTML = html; tipEl.classList.add('is-on'); } }
  function hideTip() { if (tipEl) tipEl.classList.remove('is-on'); }
  function showVerdict(html) {
    if (!verdictEl) return;
    verdictEl.innerHTML = html;
    verdictEl.style.transition = 'opacity .4s, transform .4s';
    verdictEl.style.opacity = '1';
    verdictEl.style.transform = 'translateY(0) scale(1)';
  }
  function hideVerdict() {
    if (verdictEl) { verdictEl.style.opacity = '0'; verdictEl.style.transform = 'translateY(10px) scale(.96)'; }
  }

  function renderStageDots() {
    if (!stagesEl) return;
    stagesEl.innerHTML = '';
    for (var i = 0; i < STAGES.length; i++) {
      var d = document.createElement('span');
      d.className = 'tut__stage-dot' + (i < s.stage || s.mode === 'done' ? ' is-done' : (i === s.stage ? ' is-active' : ''));
      stagesEl.appendChild(d);
    }
  }
  function markAllDots() {
    if (!stagesEl) return;
    var dots = stagesEl.children;
    for (var i = 0; i < dots.length; i++) dots[i].className = 'tut__stage-dot is-done';
  }

  function buzz(ms) { try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) { /* ok */ } }

  /* PLATZHALTER · echte Gips-Sounds (sattes Klicken beim Einrasten, dumpfes
     Poltern beim Einsturz) folgen als Audio-Assets. Winziger Synth-Klick solange: */
  function clickSound() {
    try {
      if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      var t = audioCtx.currentTime;
      var osc = audioCtx.createOscillator(), gain = audioCtx.createGain();
      osc.frequency.setValueAtTime(190, t);
      osc.frequency.exponentialRampToValueAtTime(70, t + 0.07);
      gain.gain.setValueAtTime(0.12, t);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.09);
      osc.connect(gain); gain.connect(audioCtx.destination);
      osc.start(t); osc.stop(t + 0.1);
    } catch (e) { /* audio optional */ }
  }

  function inPoly(p, pts) {
    var c = false, i, j;
    for (i = 0, j = pts.length - 1; i < pts.length; j = i++) {
      if ((pts[i][1] > p[1]) !== (pts[j][1] > p[1]) &&
          p[0] < (pts[j][0] - pts[i][0]) * (p[1] - pts[i][1]) / (pts[j][1] - pts[i][1]) + pts[i][0]) c = !c;
    }
    return c;
  }

  /* ================= loop + init ================= */

  function tick() {
    requestAnimationFrame(tick);
    if (visible) draw();
  }

  function init() {
    canvas = document.getElementById('tut-canvas');
    if (!canvas || !CORE) return;
    ctx = canvas.getContext('2d');
    taskEl = document.getElementById('tut-task');
    tipEl = document.getElementById('tut-tip');
    verdictEl = document.getElementById('tut-verdict');
    resetBtn = document.getElementById('tut-reset');
    nextBtn = document.getElementById('tut-next');
    stagesEl = document.getElementById('tut-stages');
    moreEl = document.getElementById('tut-more');

    canvas.addEventListener('pointerdown', onDown);
    canvas.addEventListener('pointermove', onMove);
    canvas.addEventListener('pointerup', onUp);
    canvas.addEventListener('pointercancel', function () { s.drag = null; });
    resetBtn.addEventListener('click', function () { enterStage(s.stage); });
    nextBtn.addEventListener('click', nextStage);

    var io = new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible && introPending) { introPending = false; startIntroCollapse(); }
    }, { threshold: 0.05 });
    io.observe(canvas);

    // resume where the visitor left off (doc: Abbruchprävention)
    var saved = window.KajuReise ? window.KajuReise.getSection('tutorial') : null;
    enterStage(typeof saved === 'number' && saved > 0 && saved < STAGES.length ? saved : 0);
    requestAnimationFrame(tick);
  }

  if (IS_BROWSER) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  /* ================= headless self-test ================= */

  function selfTestReise() {
    var CORE2 = CORE || require('../../kaju-erlebnis-nacht/js/bauprobe.js')._internals;
    var cases = [];
    function test(name, fn) {
      try { var r = fn(); cases.push({ name: name, ok: !!(r && r.ok !== false), info: r && r.info || '' }); }
      catch (e) { cases.push({ name: name, ok: false, info: 'threw: ' + e.message }); }
    }
    function ev(stones, key, bridges) { return CORE2.evaluateArch(stones, key, bridges || {}); }
    var oo = function () { return { type: 'orange', inverted: false }; };
    var gg = function () { return { type: 'gelb', inverted: false }; };
    var grr = function () { return { type: 'gruen', inverted: false }; };
    test('A rettung: [o,o]+gelb ist stabil', function () {
      return { ok: ev([oo(), oo()], 'gelb').state === 'stable' };
    });
    test('A intro: [o,o] ohne Key kollabiert', function () {
      var m = CORE2.archModel([oo(), oo()], null, {});
      var w = CORE2.createCollapseWorld(m.chain), n = 0;
      while (!w.settled && n++ < 1440) CORE2.stepWorld(w);
      return { ok: w.settled && w.outcome === 'collapsed', info: 'outcome=' + w.outcome };
    });
    test('B dreigelb: [g]+gelb stabil', function () {
      return { ok: ev([gg()], 'gelb').state === 'stable' };
    });
    test('C tausch: [o,o]+gelb (Parabel) stabil', function () {
      return { ok: ev([oo(), oo()], 'gelb').state === 'stable' };
    });
    test('D tausch: [o,gr,gr]+gelb und [gr,gr,o]+gelb stabil', function () {
      return { ok: ev([oo(), grr(), grr()], 'gelb').state === 'stable' &&
                   ev([grr(), grr(), oo()], 'gelb').state === 'stable' };
    });
    test('E weiche: [o,worange(o,o),o] + gelb-Bruecke stabil + allClosed', function () {
      var st = [oo(), { type: 'worange', rot: 0, side: [oo(), oo()] }, oo()];
      var r = ev(st, null, { '1': { type: 'gelb' } });
      return { ok: r.state === 'stable' && r.model.allClosed, info: r.state };
    });
    var pass = 0;
    cases.forEach(function (c) { if (c.ok) pass++; });
    return { pass: pass, fail: cases.length - pass, total: cases.length, cases: cases };
  }

  // read-only introspection for tests/debugging (mirrors KajuBauprobe.probe)
  function probe() {
    if (!ctx) return null;
    var m = model();
    return {
      stage: STAGES[s.stage].id, mode: s.mode, stepIdx: s.stepIdx, marked: s.marked,
      chainScreen: m.chain.map(function (it) { return w2s(it.centroid); }),
      chainTypes: m.chain.map(function (it) { return it.type; }),
      tray: s.tray.map(function (t) { return t.type + 'x' + t.count; }),
      trayRects: trayRects.map(function (t) { return { type: t.type, x: t.x, y: t.y, w: t.w, h: t.h }; })
    };
  }

  var API = { selfTestReise: selfTestReise, probe: probe };
  if (IS_BROWSER) window.KajuReiseTutorial = API;
  else if (typeof module !== 'undefined' && module.exports) module.exports = API;
})();
